module.exports = __webpack_public_path__ + "static/media/README.d512e621.md";